import { render, staticRenderFns } from "./DiscountPicker.vue?vue&type=template&id=9daa4b24"
import script from "./DiscountPicker.vue?vue&type=script&lang=js"
export * from "./DiscountPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports